import html2canvas, { Options } from 'html2canvas';

import { getBodyScrollPositionX, getBodyScrollPositionY } from './dom-element-helpers';

export enum ScreenshotType {
  Blob = 'blob',
  Base64 = 'base64',
  Canvas = 'canvas',
}

export default async function getScreenshot(
  querySelector = 'body',
  opts?: Partial<Options>, // eslint-disable-line no-undef
  type: ScreenshotType = ScreenshotType.Base64,
): Promise<Blob | string | HTMLCanvasElement> {
  if (typeof document === 'undefined') {
    return undefined;
  }

  const region: HTMLElement = document.querySelector(querySelector); // whole screen

  try {
    const canvas = await html2canvas(region, {
      logging: false,
      useCORS: true,
      allowTaint: true,
      x: getBodyScrollPositionX(),
      y: getBodyScrollPositionY(),
      width: window.innerWidth,
      height: window.innerHeight,
      ...opts,
    });

    switch (type) {
      case ScreenshotType.Base64: {
        return canvas.toDataURL();
      }
      case ScreenshotType.Blob: {
        return new Promise((resolve) => {
          if (!canvas.toBlob) {
            return resolve(undefined);
          }

          return canvas.toBlob((file) => {
            resolve(file);
          }, 'image/jpeg');
        });
      }
      case ScreenshotType.Canvas: {
        return canvas;
      }
      default: {
        return undefined;
      }
    }
  } catch (err) {
    return undefined;
  }
}
